import { createTabsDriver } from '../../primitives/tabs/driver';
export var createTabsContainerDriver = function (wrapper) {
    var base = wrapper.$(".tabs-container");
    var tabsDriver = createTabsDriver(base);
    return {
        getTabTexts: function () { return tabsDriver.getTabTexts(); },
        getSelected: function () { return tabsDriver.getSelected(); },
        getSelectedIdx: function () { return tabsDriver.getSelectedIdx(); },
        selectTab: function (idx) { return tabsDriver.selectTab(idx); }
    };
};
//# sourceMappingURL=driver.js.map